<template>
  <div>
    <item-header type="condition" @close="$emit('close')">
      <condition-label :condition-id="conditionId" style="font-weight: 500" />
    </item-header>

    <menu-group>
      <condition-input :condition-id="conditionId" />
    </menu-group>
  </div>
</template>

<script setup lang="ts">
import MenuGroup from "@core/ui/MenuGroup.vue";
import ItemHeader from "@editor/components/ItemHeader.vue";
import ConditionInput from "@editor/items/condition/ConditionInput.vue";
import ConditionLabel from "@editor/items/condition/ConditionLabel.vue";

defineProps<{
  conditionId: number;
}>();

defineEmits<{
  (event: "close"): void;
}>();
</script>

<style></style>
